module.exports = __webpack_public_path__ + "img/italy-skin-connective-and-musculoskeletal-diseases-female.ed265d39.png";